export const REMOVE_SHORT_REPLAYS_USER_SETTINGS_KEY = 'sessionReplayRemoveShortReplays';

export const FIVE_SECONDS_IN_MS = 5000;
